import { createContext, useContext } from 'react';

import { DateValue } from '../../types';

export type MonthSelectorContextValue = {
	currentYear: number;
	disableMonthIf?: (month: Date) => boolean;
	displayFormat?: 'short' | 'long';
	interimValue: DateValue;
	isClearable?: boolean;
	isDisabled?: boolean;
	isOpen: boolean;
	onClear: () => void;
	onClose: () => void;
	onHoverMonth: (month: Date) => void;
	onNextYear: () => void;
	onOpen: () => void;
	onPrevYear: () => void;
	onSelectMonth: (month: DateValue) => void;
	onClearHover: () => void;
	selectionEnd: DateValue;
	selectionStart: DateValue;
	value: DateValue;
};

export const MonthSelectorContext = createContext<MonthSelectorContextValue | undefined>(undefined);

export const useMonthSelectorContext = (): MonthSelectorContextValue => {
	const context = useContext(MonthSelectorContext);

	if (!context) {
		throw new Error('useMonthSelectorContext must be used within a MonthSelectorContext');
	}

	return context;
};
